import MembershipDocumentListResourcePagingResultModel from '../../generated/types/model/resource/MembershipDocumentListResourcePagingResultModel';

export default class MembershipDocumentListResourcePagingResultViewModel extends MembershipDocumentListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
